import { useCallback } from "react";

import Folder from "@mui/icons-material/Folder";
import ViewAgenda from "@mui/icons-material/ViewAgenda";
import type { ToggleButtonProps } from "@mui/material";
import Box from "@mui/material/Box";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export enum DataEntryView {
  PROCESS = "PROCESS",
  FOLDER = "FOLDER",
}

export type DataEntryViewToggleProps = {
  value: DataEntryView;
  onChange: (view: DataEntryView) => void;
};

const DataEntryViewToggle = ({ value, onChange }: DataEntryViewToggleProps) => {
  const handleToggleButtonGroupClick = useCallback<NonNullable<ToggleButtonProps["onChange"]>>(
    (_event, newView: DataEntryView | null) => {
      if (!newView) {
        return;
      }
      onChange(newView);
    },
    [onChange],
  );

  return (
    <Box padding={0}>
      <ToggleButtonGroup
        exclusive
        value={value}
        onChange={handleToggleButtonGroupClick}
        sx={{ display: "inline-flex" }}
      >
        <ToggleButton value={DataEntryView.PROCESS}>
          <ViewAgenda />
        </ToggleButton>
        <ToggleButton value={DataEntryView.FOLDER}>
          <Folder />
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default DataEntryViewToggle;
